import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../styles/subjectform.css";
import Cookies from "js-cookie";
import api from "../../api.js";

const user_id = Cookies.get("user_id");
const token = Cookies.get("access_token");

const SubjectForm = ({ show, handleClose, fieldId, subjects }) => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    parent: "", // new field
  });


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append("title", formData.title);
    formDataToSend.append("description", formData.description);
    formDataToSend.append("author", user_id);
    formDataToSend.append("field", fieldId);
    if (formData.parent !== "") {
  formDataToSend.append("parent", parseInt(formData.parent));
}


    try {
      await api.post(`/subject/field/${fieldId}/`, formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      window.location.reload();
    } catch (error) {
      console.error("Error creating subject:", error);
    }
  };

  return (
    <div className={`modal ${show ? "d-block" : "d-none"}`} style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="btn-close" onClick={handleClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">عنوان</label>
                <input type="text" className="form-control" name="title" value={formData.title} onChange={handleChange} required />
              </div>
              <div className="mb-3">
                <label className="form-label">توضیحات (اختیاری)</label>
                <textarea className="form-control" name="description" value={formData.description} onChange={handleChange} />
              </div>
              <div className="mb-3">
                <label className="form-label">موضوع والد</label>
                <select className="form-select" name="parent" value={formData.parent} onChange={handleChange}>
                  <option value="">— بدون والد —</option>
                  {subjects.map(subject => (
                    <option key={subject.id} value={subject.id}>{subject.title}</option>
                  ))}
                </select>
              </div>
              <button type="submit" className="btn-submit btn-primary">ثبت</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubjectForm;
